import request from "@/utils/request";
export function uploadImg(data) {
  return request({
    url: "/auth/upload/img",
    method: "POST",
    data
  });
}